// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MEAqRch4s5UmsxvQ0vzk {
  margin: 140px auto;
  width: 90%;
  max-width: 1440px;
}

.IZsDd3qUmO2kJBtMuEJg {
  display: grid;
  grid-template-columns: 1;
  grid-gap: 10%;
  margin-top: 2%;
}

.xqrBObuxB0AiszOxIWLK {
  display: flex;
  flex-direction: column;

  background-color: white;
  box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 30px;
  
  max-width: 650px;
  width: 85vw;
  margin: auto;
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]};
}

.m5Svy3eJSldNwPMyxHqG {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.xqrBObuxB0AiszOxIWLK button.HAYu8Zdji91LLP8xAuU0 {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  background-color: white;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
  margin-top: 20px;
  margin-bottom: 20px;
}

.hLiauSpQWtFGx0wkRpvi {
  text-align: center;
  color: #5CCA54;
  font-size: 0;
}

.LBZ6bjPWhzsGVk07dAaO {
  font-size: 100px;
}

.DIy7Nihr89LHayJv1d7T {
  font-weight: bold;
  text-align: center;
}

.kmHODeQI3WnYcPzNIGSw {
  text-align: center;
}

.DKCO9loAQqqgmxXw3fxg {
  position: absolute;    
  inset: 40px;
  margin: auto;
  padding: 40px;
  outline: none;
  overflow: auto;
  border-radius: 10px;
  background: rgb(255, 255, 255);
  max-width: 80vw;
  max-height: 80vh;
  padding-top: 0;
  padding-bottom: 20px;
}

.bb1TxDFGwb9NQqqkKIcW {
  z-index: 1000;
  position: fixed;
  inset: 0px;
  background-color: rgba(0, 0, 0, 0.4);
}

.pJcCqkFnQIWjDTj84mzV {
  display: none;
}

.ZEeYLhdjTDHloW_C7Z2y {
  display: block;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .IZsDd3qUmO2kJBtMuEJg {
    display: grid;
    grid-template-columns: 1;
    grid-gap: 10%;
  }

  .MEAqRch4s5UmsxvQ0vzk {
    width: 100%;
  }

  .pJcCqkFnQIWjDTj84mzV {
    margin-left: 20px;
    margin-right: 20px;
    display: block;
  }

  .ZEeYLhdjTDHloW_C7Z2y {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/DownloadInvoice/DownloadInvoice.module.css"],"names":[],"mappings":"AAMA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;;EAEb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mDAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mDAAmB;EACnB,uBAAuB;EACvB,8DAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,wBAAwB;IACxB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@value breakpoints: \"components/library/style/breakpoint.css\";\n@value tablet-l from breakpoints;\n\n@value colors: \"components/library/style/colors.css\";\n@value color-text, color-purple, color-success-dark from colors;\n\n.content {\n  margin: 140px auto;\n  width: 90%;\n  max-width: 1440px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: 1;\n  grid-gap: 10%;\n  margin-top: 2%;\n}\n\n.flexBox {\n  display: flex;\n  flex-direction: column;\n\n  background-color: white;\n  box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.06);\n  border-radius: 10px;\n  padding: 30px;\n  \n  max-width: 650px;\n  width: 85vw;\n  margin: auto;\n  color: color-text;\n}\n\n.flexColumn {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.flexBox button.downloadButton {\n  color: color-purple;\n  background-color: white;\n  border: 1px solid color-purple;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.icon {\n  text-align: center;\n  color: #5CCA54;\n  font-size: 0;\n}\n\n.materialIcons {\n  font-size: 100px;\n}\n\n.title {\n  font-weight: bold;\n  text-align: center;\n}\n\n.subTitle {\n  text-align: center;\n}\n\n.modal {\n  position: absolute;    \n  inset: 40px;\n  margin: auto;\n  padding: 40px;\n  outline: none;\n  overflow: auto;\n  border-radius: 10px;\n  background: rgb(255, 255, 255);\n  max-width: 80vw;\n  max-height: 80vh;\n  padding-top: 0;\n  padding-bottom: 20px;\n}\n\n.modalOverlay {\n  z-index: 1000;\n  position: fixed;\n  inset: 0px;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.mobile {\n  display: none;\n}\n\n.desktop {\n  display: block;\n}\n\n@media screen and (max-width: tablet-l) {\n  .grid {\n    display: grid;\n    grid-template-columns: 1;\n    grid-gap: 10%;\n  }\n\n  .content {\n    width: 100%;\n  }\n\n  .mobile {\n    margin-left: 20px;\n    margin-right: 20px;\n    display: block;\n  }\n\n  .desktop {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"colors": `"components/library/style/colors.css"`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"color-success-dark": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-success-dark"]}`,
	"content": `MEAqRch4s5UmsxvQ0vzk`,
	"grid": `IZsDd3qUmO2kJBtMuEJg`,
	"flexBox": `xqrBObuxB0AiszOxIWLK`,
	"flexColumn": `m5Svy3eJSldNwPMyxHqG`,
	"downloadButton": `HAYu8Zdji91LLP8xAuU0`,
	"icon": `hLiauSpQWtFGx0wkRpvi`,
	"materialIcons": `LBZ6bjPWhzsGVk07dAaO`,
	"title": `DIy7Nihr89LHayJv1d7T`,
	"subTitle": `kmHODeQI3WnYcPzNIGSw`,
	"modal": `DKCO9loAQqqgmxXw3fxg`,
	"modalOverlay": `bb1TxDFGwb9NQqqkKIcW`,
	"mobile": `pJcCqkFnQIWjDTj84mzV`,
	"desktop": `ZEeYLhdjTDHloW_C7Z2y`
};
export default ___CSS_LOADER_EXPORT___;
